import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Alert, Button, Col, Row, Card } from '@paypalcorp/pp-react';
import * as FPT from '../../utility/fpt';
import { fetchResponse } from '../../common/serviceRequest';
import { get } from 'lodash';
import { show, hide } from '../../common/domUtils';
import TermsContent from './TermsContent';
import withTheme from '../../common/withTheme';

class Consent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            serviceError: false,
            flow: 'enrollment',
        };
    }

    consentSubmit = async () => {
        const csrf = document.getElementsByTagName('body')[0].getAttribute('data-csrf');
        show('.loadingspinner', 'flex');
        let payload = { _csrf: csrf }
        FPT.trackButtonClick('consentSubmitBtn');
        try {
            const response = await fetchResponse('/givingfund/enroll/consentSubmit', 'POST', payload);
            hide('.loadingspinner');
            if (response.submitResult) {
                FPT.trackPageWithData('main:givingfund:enroll:completed', { enrollStatus: 'completed' });
                this.props.updateEnrollStatus("completed");
            } else {
                throw "Service Error";
            }
        } catch (error) {
            hide('.loadingspinner');
            FPT.trackPageWithData('main:givingfund:enroll:showconsent:error', { enrollStatus: 'showConsent' });
            this.setState({ serviceError: true });
            window.scrollTo(0, 0);
        }
    }

    render() {
        return (<Card card className="enroll showconsent">
            {this.state.serviceError && <Alert type="error">{ReactHtmlParser(get(this.props.propertyInfo, 'directmodel.enroll.errorMsg'))}</Alert>}
            <TermsContent propertyInfo={this.props.propertyInfo} flow={this.state.flow}/>
            <Row>
                <Col style={{ textAlign: "center" }}>
                    <Button onClick={this.consentSubmit} id="consentSubmit">{get(this.props.propertyInfo, 'directmodel.consent.continue')}</Button>
                </Col>
            </Row>
        </Card>)
    }
}
export default withTheme(Consent);